<template>
  <div>

    <c-card
      v-for="project in projects"
      :key="project.rating_code"
      class="project"
    >

      <c-title tag="h3">
        {{ project.title }}
      </c-title>

      <p
        v-if="project.is_lead"
        class="project__role"
      >
        <c-badge :type="badgeType['Projektvorschlag eingereicht']">
          <span>Projektleiter</span>
        </c-badge>
      </p>

      <p
        v-else-if="!project.is_lead"
        class="project__role"
      >
        <c-badge :type="badgeType['Projektvorschlag eingereicht']">
          <span>Redakteur</span>
        </c-badge>
      </p>

      <p class="project__status">
        <c-badge :type="badgeType[project.status]">
          {{ project.status }}
        </c-badge>
      </p>

      <p v-if="project.rating_code && project.status === 'Projektvorschlag eingereicht'">Bewertungscode: <strong>{{ project.rating_code }}</strong></p>
      <p v-else-if="!project.rating_code && project.status === 'Projektvorschlag eingereicht'">Sie erhalten einen <strong>Bewertungscode</strong>, sobald Ihr Projektvorschlag für die Bewertung freigeschaltet wurde. Bitte wenden Sie sich an die Claussen-Simon-Stiftung, um Ihren Vorschlag zur Freischaltung einzureichen.</p>

      <p>
        <c-button-router-link
          v-if="project.rating_code"
          :to="{
            name: 'project-rating-list',
            params: { identifier: project.identifier }
          }"
        >
          Bewertungen
        </c-button-router-link>

        <c-button-router-link
          v-if="project.status === 'Projektvorschlag eingereicht' && $is(['professor', 'teacher']) && new Date($store.state.user.data.project_deadline) > new Date()"
          :to="{
            name: 'project-edit',
            params: { identifier: project.identifier }
          }"
        >
          Projekt bearbeiten
        </c-button-router-link>

        <c-button
          v-if="($is(['professor', 'teacher']) && new Date($store.state.user.data.project_deadline) <= new Date()) || $is(['css_supervisor'])"
          @click="showSummary(project.identifier)"
        >
          PDF Zusammenfassung herunterladen
        </c-button>
      </p>

    </c-card>

    <c-busy v-if="loadStatus === $config.status.LOADING" />

    <c-button-router-link
      v-else-if="!hasProposedProject && new Date($store.state.user.data.project_deadline) > new Date()"
      :to="{ name: 'project-proposal'}"
    >
      Vorschlag erstellen
    </c-button-router-link>
  </div>
</template>

<script>
import CBadge from '@/components/CBadge'
import CButtonRouterLink from '@/components/CButtonRouterLink'
import CBusy from '@/components/CBusy'
import CCard from '@/components/CCard'
import CTitle from '@/components/CTitle'
import CButton from '@/components/CButton'

import handleRequestError from '@/functions/handleRequestError'

import config from '@/config'

export default {
  name: 'CProjectOverview',

  components: {
    CBadge,
    CButton,
    CButtonRouterLink,
    CBusy,
    CCard,
    CTitle
  },

  data () {
    return {
      loadStatus: this.$config.status.IDLE,
      projects: [],
      badgeType: {
        'Förderung erhalten': 'success',
        'Förderung abgelehnt': 'error'
      }
    }
  },

  computed: {
    hasLeadInProject () {
      if (this.projects.filter(project => project.is_lead).length) {
        return true
      }
      return false
    },

    hasProposedProject () {
      if (this.projects.filter(project => project.status === 'Projektvorschlag eingereicht').length) {
        return true
      }

      return false
    }
  },

  created () {
    this.loadStatus = this.$config.status.LOADING

    this.$api.get('projects/project/')
      .then(response => {
        this.projects = response.data
        this.loadStatus = this.$config.status.SUCCESS
      })
      .catch(error => {
        handleRequestError({
          error,
          text: 'Ihre Projekte konnten nicht geladen werden. Bitte versuchen sie es später erneut.'
        })

        this.loadStatus = this.$config.status.ERROR
      })
  },

  methods: {
    showSummary (identifier) {
      let url = config.appUrl + '/api/projects/project-summary/?identifier=' + identifier
      window.open(url, '_blank')
    }
  }
}
</script>

<style>
@media (min-width: 800px) {
  .project {
    position: relative;
  }

  .project__role {
    position: absolute;
    top: 1em;
    right: 1em;
  }
}
</style>
